import { render, staticRenderFns } from "./AllInvestmentsReceivablesHead.vue?vue&type=template&id=2b593d10&"
import script from "./AllInvestmentsReceivablesHead.vue?vue&type=script&lang=js&"
export * from "./AllInvestmentsReceivablesHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports